import React, { Component } from 'react';
import AutoRepliesComponent from '../../../../../../components/AutoReplies';

/**
 * Auto replies screen, for showing auto replies config page.
 *
 * @extends React.Component
 */
class AutoReplies extends Component {
  render() {
    return (
      <AutoRepliesComponent />
    );
  }
}

export default AutoReplies;



// WEBPACK FOOTER //
// ./src/screens/AdvisoryApp/screens/Settings/screens/AutoReplies/index.js